/**
 * @license
 * Copyright 2022 Superflows.dev
 * SPDX-License-Identifier: MIT
 */

import {SfIForm} from '../sf-i-form.js';
// import { stub } from 'sinon';
// import {fixture, assert} from '@open-wc/testing';
import {assert} from '@open-wc/testing';
// import {html} from 'lit/static-html.js';

//const TIMEOUT = 2000;
suite('sf-i-form > left menu', () => {

  test('is defined', () => {
    const el = document.createElement('sf-i-form');
    assert.instanceOf(el, SfIForm);
  });


});

